<div
  mxc-form-control
  *ngIf="autocompleteFormControl"
  [status]="autocompleteFormControl?.dirty && autocompleteFormControl?.invalid ? 'error' : 'neutral'"
  size="md"
  class="mxc-mb-2"
>
  <label for="input" mxc-label [attr.required]="required || null">{{ label }}</label>
  <div mxc-input-wrap>
    <input
      id="input"
      type="text"
      mxc-input
      [formControl]="autocompleteFormControl"
      [matAutocomplete]="auto"
      [placeholder]="placeholder"
      [attr.required]="required || null"
      (blur)="onBlur()"
      (focus)="onFocus()"
      (keyup)="handleValueChange($event)"
    />
    <div mxc-input-element *ngIf="loading">
      <div mxc-spinner size="sm" role="progressbar" aria-label="progress spinner"></div>
    </div>
    <div mxc-input-status-icon></div>
  </div>
  <span mxc-help-text *ngIf="helpText && (autocompleteFormControl.pristine || autocompleteFormControl.valid)">
    {{ helpText }}
  </span>

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectOption()">
    <mat-option [disabled]="option.disabled" *ngFor="let option of options" [value]="option.value">
      <span [ngClass]="['d-flex', 'justify-content-between', option.className || '']">
        {{ option.label }}
        <span>
          <msp-icon *ngIf="option.icon" [config]="{ name: option.icon, size: 'xsmall' }"></msp-icon>
          <msp-icon
            *ngIf="option.tooltip"
            [config]="{ name: 'icon-info', size: 'xsmall', fill: 'auto' }"
            [matTooltip]="option.tooltip"
          ></msp-icon>
        </span>
      </span>
    </mat-option>
  </mat-autocomplete>
  <ng-container *ngIf="showError">
    <div mxc-error-text *mxcFormControlError>
      <div *ngIf="autocompleteFormControl.hasError('required')">{{ label }} is required</div>
      <div *ngIf="autocompleteFormControl.hasError('autocompleteNoResult')">
        {{ errorMessages.autocompleteNoResult }}
      </div>
      <ng-content select="[customErrors]"></ng-content>
    </div>
  </ng-container>
</div>
